import { Col, Datepicker, DropdownBox, InputField, Label, SwitchToggle, Tooltip } from "client/CommonComponents"
import './TaskGrid.scss'
import CompletedIcon from '../../../../../assets/images/Completed.svg'
import UpNextIcon from '../../../../../assets/images/Up Next.svg'
import NotStartedIcon from '../../../../../assets/images/Not Started.svg'
import NA from '../../../../../assets/images/NA.svg'
import DelayedIcon from '../../../../../assets/images/Delayed.svg'
import pendingIcon from '../../../../../assets/images/Pending.svg'
import { CONSTANTS } from "client/utils/constants"
import CancelConfirmationPopup from "client/CommonComponents/DialogBox/CancelConfirmationPopup"
import { useMemo } from "react"
import { FLEET_PROCESSING_PERMISSIONS } from "client/utils/constants/fleetProcessingPermissions"
import permissions, { isAuthorized } from "client/utils/Permissions";
import TaskReset from '../../../../../assets/images/TaskReset.svg'

const TaskGrid = (props:any) =>{

    const {
        taskItemDetails,
        handleOnChange,
        handleOnBlur,
        Popupcontent,
        hideDialog,
        assignTo,
        onChangeAssignedTo,
        taskHeaderDetails,
        onChangeComment,
        onBlurComment,
        handleClickReset,
        editComment
    } = props;
    
    const assignedToValue = useMemo(() => {
        return assignTo?.find(
            (x: any) => x?.value?.toLowerCase() == taskHeaderDetails?.assignedTo?.toLowerCase()
        );
    }, [taskHeaderDetails.assignedTo, assignTo]);

    const isEditComment = (selectedItem: any) => {
        if (editComment?.length) {
            const edit = editComment?.find(
                (x: any) => x?.id == selectedItem.poFleetRequestTaskListTrackingId
            );
            return !edit?.isShowTextBox
        }
    }

    const iconReturn = (status: any) => {
        let src = "";
        switch (status) {
            case "Completed":
                src = CompletedIcon;
                break;
            case "Up Next":
                src = UpNextIcon;
                break;
            case "Delayed":
                src = DelayedIcon;
                break;
            case "Not Started":
                src = NotStartedIcon;
                break;
            case "N/A":
                src = NA;
                break;
            case "Pending":
                src = pendingIcon;
                break;
            default:
                break;
        }
        return <><img src={src} alt="Error Image" className="error-image" /><span>{status}</span></>;
    }

    const isTaskEditable = (taskDescription: string) => {
        const isInvoiceTask = taskDescription?.toLowerCase() === CONSTANTS?.FLEET_PROCESSING_TASKS?.INVOICE_VOUCHERED || taskDescription?.toLowerCase() === CONSTANTS?.FLEET_PROCESSING_TASKS?.INVOICE_PAID;
        return isInvoiceTask && !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.EDIT_FLEET_ADMIN_INVOICE_TASKS) && !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.EDIT_FLEET_ADMIN_TASKS) && !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.UPDATE_FLEET_ADMIN_TASKS);
    }

    return(<>
    <div className='assignedSelectBox px-3'>
    <div className='attachment-bulkorder-fleet'>
                <Label required data-attribute="TaskGrid_Default_Label">Assigned To</Label>
                <DropdownBox
                    name="assignedTo"
                    placeholder="Select"
                    options={assignTo}
                    onChange={(e:any, selectedItem:any)=>onChangeAssignedTo(selectedItem)}
                    className={taskHeaderDetails?.assignedToError ? 'controlValidation' : ""}
                    selectedKey={assignedToValue?.key}
                    disabled = {(taskHeaderDetails?.fleetStatus == CONSTANTS.ITEM_STATUS.REQUISITION_COMPLETE || taskHeaderDetails?.fleetStatus == CONSTANTS.ITEM_STATUS.CANCELLED || !(isAuthorized(FLEET_PROCESSING_PERMISSIONS?.EDIT_FLEET_ADMIN_TASKS) || isAuthorized(FLEET_PROCESSING_PERMISSIONS?.UPDATE_FLEET_ADMIN_TASKS)))}
                 data-attribute="TaskGrid_assignedTo_Dropdown" />
                <p className='validMessage'>{taskHeaderDetails?.assignedToError ? taskHeaderDetails?.assignedToError : '    '}</p>
            </div>
            {
                taskHeaderDetails?.itemStatus === CONSTANTS.ITEM_STATUS.CANCELLED &&
                <div className="cancelled-comments-div">
                    <Label data-attribute="TaskGrid_Default_Label_2">Cancelled Comments</Label>
                    <Tooltip content={taskHeaderDetails?.cancelComments ?? "-"} data-attribute="TaskGrid_Default_Tooltip">
                        <div>{taskHeaderDetails?.cancelComments ?? "-"}</div>
                    </Tooltip>
                </div>
            }
    </div>

            <Col xs={12} md={12} lg={12} className="p-3">
                <div className="admin-sttepper-content">
                    <div className="header-block">
                        <p className="step">Step</p>
                        <p className="task">Task</p>                      
                        <p className="completeddate">Completed Date</p>
                        <p className="comments">Comments</p>
                        <p className="completedby">Completed By</p>
                        <p className="status">Status</p>
                        <p className="Na_block">N/A</p>
                    </div>
                    <div className="content-block">
                    {
                        taskItemDetails?.map((item:any, index:any)=>{
                            return(
                                <div className="content-with-warning">
                                    <div className="content-card" key={index}>
                                        <p className="step">{item.step}</p>
                                        <div className="content-card nested-right-block" key={index}>
                                        {
                                            item?.list.map((itemValue:any)=>{
                                                return(<div className={`rowspan-block ${itemValue.taskStatus}`}>
                                                    <p className="task">{itemValue.taskDescription}</p>
                                                    <p className="completeddate"> 
                                                        <Datepicker
                                                            placeholder="MM/DD/YYYY"
                                                            allowTextInput={true}
                                                            value={(!itemValue?.isApplicable && itemValue?.completedOn) ? new Date(itemValue?.completedOn) : null}
                                                            onChangeDate={(date: any) => handleOnChange(date,'completedOn',itemValue,item.step)}
                                                            maxDate={(itemValue?.taskDescription?.toLowerCase() === CONSTANTS?.FLEET_PROCESSING_TASKS?.ESTIMATED_DELIVERY_DATE || itemValue?.taskDescription?.toLowerCase() === CONSTANTS?.FLEET_PROCESSING_TASKS.INVOICE_VOUCHERED) ? '' : new Date()}
                                                            disabled={itemValue?.taskStatus == CONSTANTS.ORDER_STATUS.NBYA || taskHeaderDetails?.fleetStatus == CONSTANTS.ITEM_STATUS.CANCELLED || taskHeaderDetails?.fleetStatus == CONSTANTS.ITEM_STATUS.REQUISITION_COMPLETE || isTaskEditable(itemValue?.taskDescription) || !(isAuthorized(FLEET_PROCESSING_PERMISSIONS?.EDIT_FLEET_ADMIN_TASKS) || isAuthorized(FLEET_PROCESSING_PERMISSIONS?.UPDATE_FLEET_ADMIN_TASKS))}
                                                         data-attribute="TaskGrid_Default_Datepicker" />
                                                        {(taskHeaderDetails?.fleetStatus != CONSTANTS.ITEM_STATUS.CANCELLED && taskItemDetails?.itemStatus !== CONSTANTS.ORDER_STATUS.CANCELLED && isAuthorized(FLEET_PROCESSING_PERMISSIONS?.EDIT_FLEET_ADMIN_TASKS) && isAuthorized(FLEET_PROCESSING_PERMISSIONS?.UPDATE_FLEET_ADMIN_TASKS)) ?
                                                            <Tooltip content={"Reset"} data-attribute="TaskGrid_Default_Tooltip_2">
                                                                <input type="image" src={TaskReset}
                                                                    className="ms-2 mt-0 mb-1 completed-reset"
                                                                    onClick={() => handleClickReset(itemValue, item.step)}
                                                                    disabled={isTaskEditable(itemValue?.taskDescription)}
                                                                 data-attribute="TaskGrid_Default_Input" />
                                                            </Tooltip>
                                                            : null}
                                                    </p>

                                                    <p className="comments" onClick={(e:any)=>props?.handleClickComment(e,itemValue?.poFleetRequestTaskListTrackingId)}>
                                                        {isEditComment(itemValue) ? <Tooltip content={itemValue?.comment} data-attribute="TaskGrid_Default_Tooltip_3">{itemValue?.comment}</Tooltip> :
                                                            <>
                                                                <Tooltip content={itemValue?.comment} data-attribute="TaskGrid_Default_Tooltip_4">
                                                                    <InputField
                                                                        name='comment'
                                                                        value={itemValue?.comment}
                                                                        onChange={(e: any) => handleOnChange(e.target.value, 'comment', itemValue, item.step, e)}
                                                                        onBlur={handleOnBlur}
                                                                        disabled={taskHeaderDetails?.fleetStatus == CONSTANTS.ITEM_STATUS.CANCELLED || taskHeaderDetails?.fleetStatus == CONSTANTS.ITEM_STATUS.REQUISITION_COMPLETE || isTaskEditable(itemValue?.taskDescription) || !(isAuthorized(FLEET_PROCESSING_PERMISSIONS?.EDIT_FLEET_ADMIN_TASKS) || isAuthorized(FLEET_PROCESSING_PERMISSIONS?.UPDATE_FLEET_ADMIN_TASKS))}
                                                                     data-attribute="TaskGrid_comment_Input" />
                                                                </Tooltip>
                                                                <span className="validMessage">{itemValue?.commentError}</span>
                                                            </>
                                                        }
                                                    </p>
                                                    <p className="completedby">{itemValue.completedBy}</p>
                                                    <p className="status">{iconReturn(itemValue.taskStatus)}</p> 
                                                    <p className="Na_block"> 
                                                        <SwitchToggle 
                                                            className="mt-2"
                                                            checked={itemValue?.isApplicable}
                                                            onChange={(e: any) => handleOnChange(!itemValue?.isApplicable, 'isApplicable', itemValue, item.step) }
                                                            disabled = {(taskHeaderDetails?.fleetStatus == CONSTANTS.ITEM_STATUS.REQUISITION_COMPLETE || taskHeaderDetails?.fleetStatus == CONSTANTS.ITEM_STATUS.CANCELLED || isTaskEditable(itemValue?.taskDescription) || !(isAuthorized(FLEET_PROCESSING_PERMISSIONS?.EDIT_FLEET_ADMIN_TASKS) || isAuthorized(FLEET_PROCESSING_PERMISSIONS?.UPDATE_FLEET_ADMIN_TASKS) ))}
                                                         data-attribute="TaskGrid_Default_SwitchToggle" />
                                                    </p>
                                                </div>)
                                            })
                                        }
                                        </div>                                                                                                           
                                    </div>   
                                </div>
                            )
                        })
                    }
                    </div>
                </div>
            </Col>
            <Col xs={12} md={12} lg={12}>
            <div className='assign-to px-3'>
                    <Label  data-attribute="TaskGrid_Default_Label_3">Comment</Label>
                    <InputField
                        name="comment"
                        placeholder="Enter"
                        onChange={(e?: any) => { onChangeComment(e) }}
                        className={taskHeaderDetails?.commentError?.length ? 'controlValidation' : ""}
                        value={taskHeaderDetails?.comment}
                        onBlur={onBlurComment}
                        disabled = {(taskHeaderDetails?.fleetStatus == CONSTANTS.ITEM_STATUS.REQUISITION_COMPLETE || taskHeaderDetails?.fleetStatus == CONSTANTS.ITEM_STATUS.CANCELLED)}
                     data-attribute="TaskGrid_comment_Input_2" />
                    {
                        taskHeaderDetails?.commentError && (
                            <span className="validMessage">
                                {taskHeaderDetails?.commentError}
                            </span>
                        )
                    }
            </div>
                {
                    Popupcontent.isDialogVisible && (
                        <CancelConfirmationPopup
                            hideDialog={!Popupcontent.isDialogVisible}
                            onDismiss={hideDialog}
                            Popupcontent={Popupcontent}
                            popupOutlinebtnOnclick={() => Popupcontent?.popupOutlinebtnOnclick()}
                            popupPrimarybtnOnclick={() => Popupcontent?.popupPrimarybtnOnclick()}

                        />
                    )
                }
            </Col>

    </>)
}

export default TaskGrid